import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
export const loadSiteContent = () => {
  if (!cache) cache = api.get("/site-content").then((r) => r.data).catch(() => { cache = null; return null; });
  return cache;
};

export function useSiteContent() {
  const [c, setC] = useState(null);
  useEffect(() => { loadSiteContent().then(setC); }, []);
  return c;
}
